// Role names by id. Mirrors the backend's role catalogue (FM-BackEnd-v2 src/lib/auth.ts).
export const ROLE_NAMES = {
  1: 'Standard',
  2: 'Approver',
  3: 'Admin',
  4: 'Employee admin',
  5: 'Festivals manager',
  6: 'Marketing',
  7: 'Senior officer',
  8: 'Inventory manager',
  9: 'CFQ admin',
};

export const roleName = (id) => ROLE_NAMES[Number(id)] || `Role ${id}`;
